module.exports = __webpack_public_path__ + "img/ywt_logo.96eec94.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ywt_logo.png
// module id = e6wp
// module chunks = 1 2 3 6 8 15 16 18 19 20 21 22 23 24 25 37 65 67 68 69 70 71 72 73 75 87 90 127 131 148 153 156